module.exports = __webpack_public_path__ + "img/logo_dark.cac74555.png";